import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Colors, Link as LinkZDS } from '@zapier/design-system';
import { ArticleImage } from 'components/Images/ArticleImage/ArticleImage';
import { ArticleRichImage } from 'data/SingleArticle/types';
import { ImageQueryParams } from 'components/Images/RichImageComponent/RichImageComponent';

type Props = {
  image: ArticleRichImage;
  children: ReactNode;
  hyperlink: string | null;
  isNewTab: boolean;
};

const imageBlockQueryParams: Readonly<ImageQueryParams> = {
  w: '1400',
};

export const ImageBlock = ({ children, image, hyperlink, isNewTab }: Props) => {
  const imageJsx = (
    <React.Fragment>
      <CenteredAlignedDiv>
        <Image image={image} queryParams={imageBlockQueryParams} />
      </CenteredAlignedDiv>
      <Caption>{children}</Caption>
    </React.Fragment>
  );

  return (
    <Outer>
      {hyperlink ? (
        <LinkZDS
          href={hyperlink}
          color={null}
          target={isNewTab ? '_blank' : '_self'}
        >
          {imageJsx}
        </LinkZDS>
      ) : (
        imageJsx
      )}
    </Outer>
  );
};

const Outer = styled.div`
  display: grid;
`;

const Image = styled(ArticleImage)`
  border: 1px solid ${Colors.gray20};
  border-radius: 5px;
  height: auto;
  width: 100%;
`;

const Caption = styled.figcaption`
  color: ${Colors.gray80};
  > small {
    font-size: 14px;
  }
  line-height: 130%;
  margin-top: 10px;
`;

const CenteredAlignedDiv = styled.div`
  text-align: center;
`;
